export default "/images/25a21975852512ad5e8ad9671405adc8.avif";